/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as AdminDefs from '../../../com/atproto/admin/defs.defs.js'
import * as SignatureDefs from './defs.defs.js'

const $nsid = 'tools.ozone.signature.findRelatedAccounts'

export { $nsid }

/** Get accounts that share some matching threat signatures with the root account. */
const main = l.query(
  $nsid,
  l.params({
    did: l.string({ format: 'did' }),
    cursor: l.optional(l.string()),
    limit: l.optional(
      l.withDefault(l.integer({ minimum: 1, maximum: 100 }), 50),
    ),
  }),
  l.jsonPayload({
    cursor: l.optional(l.string()),
    accounts: l.array(l.ref<RelatedAccount>((() => relatedAccount) as any)),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output

type RelatedAccount = {
  $type?: 'tools.ozone.signature.findRelatedAccounts#relatedAccount'
  account: AdminDefs.AccountView
  similarities?: SignatureDefs.SigDetail[]
}

export type { RelatedAccount }

const relatedAccount = l.typedObject<RelatedAccount>(
  $nsid,
  'relatedAccount',
  l.object({
    account: l.ref<AdminDefs.AccountView>((() => AdminDefs.accountView) as any),
    similarities: l.optional(
      l.array(
        l.ref<SignatureDefs.SigDetail>((() => SignatureDefs.sigDetail) as any),
      ),
    ),
  }),
)

export { relatedAccount }
